import { debounce } from "lodash";

const getInputValueFromQuery = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('query') || '';
}

const submitSearch = (event, section) => {
    event.stopPropagation();

    const wrapper = event.currentTarget.parentElement;
    const input = wrapper.querySelector('.search-input');
    const query = input.value;

    window.location = `${window.location.origin}/${section}/search?query=${query}`
}

const clearInput = (input) => {
    input.value = '';
};

const handleSuggestion = (event, clearInput, section) => {
    const container = event.currentTarget;
    const {category, post} = container.dataset;
    clearInput(container);
    window.location = `${window.location.origin}/${section}/${category}/${post}`;
}

const removeElements = (elements = [], callback) => {
    return elements.map(element => {
        callback?.(element);
        element.remove();
    });
}

const createSuggestion = (post, handlerSuggestion, section) => {
    const suggestion = document.createElement('p');
    suggestion.classList = 'search-input__suggestion';
    suggestion.textContent = post.title;
    suggestion.dataset.category = post.category.code;
    suggestion.dataset.post = post.code;

    const eventHandler = (event) => handlerSuggestion(event, clearInput, section);
    suggestion.addEventListener('mousedown', eventHandler);
    
    // Store the eventHandler in the element for later removal
    suggestion.eventHandler = eventHandler;

    return suggestion;
}

const renderPartial = (posts, suggestionsWrapper, handlerSuggestion, section) => {
    removeElements(Array.from(suggestionsWrapper.childNodes), (element) => {
        element.removeEventListener('mousedown', element.eventHandler);
    });

    const suggestions = posts.map(post => createSuggestion(post, handlerSuggestion, section));

    suggestionsWrapper.classList.toggle('search-input__suggestions_hidden', !posts.length);
    suggestionsWrapper.append(...suggestions);
    return suggestions;
}

const searchPartial = async (query, suggestionsWrapper, renderPartial, handlerSuggestion, section) => {
    try {
        const response = await fetch(`${window.location.origin}/${section}/api-search?query=${query}&limit=3`);
        const posts = await response.json();
        return renderPartial(posts, suggestionsWrapper, handlerSuggestion, section);
    } catch (error) {
        console.log('Search modal error: ', error);
    }
}

export const initializeSearchInputs = (inputs, buttons, section) => {
    inputs.forEach(input => {
        input.value = getInputValueFromQuery();
        const debouncedSearchPartial = debounce((event) => {
            searchPartial(event.target.value, event.target.nextElementSibling, renderPartial, handleSuggestion, section);
        }, 300);

        input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                submitSearch(event, section);
            }
        });
        input.addEventListener('focusout', () => renderPartial([], input.nextElementSibling, handleSuggestion, section));
        input.addEventListener('input', debouncedSearchPartial);
        input.addEventListener('focus', debouncedSearchPartial);
    });

    buttons.forEach(button => {
        button.addEventListener('click', (event) => submitSearch(event, section));
    })
}